module.exports = __webpack_public_path__ + "img/stock5.12aa2214.png";